import { supabase } from "@/integrations/supabase/client";

interface NotificationData {
  user_id: string;
  type: string;
  title: string;
  message: string;
  link?: string;
  related_booking_id?: string;
}

/**
 * Insert a notification with deduplication
 * Prevents duplicate notifications for the same booking + type combination
 */
export async function insertNotificationOnce(data: NotificationData): Promise<boolean> {
  try {
    // Check if notification already exists for this booking and type
    if (data.related_booking_id) {
      const { data: existing } = await supabase
        .from("notifications")
        .select("id")
        .eq("related_booking_id", data.related_booking_id)
        .eq("type", data.type)
        .eq("user_id", data.user_id)
        .maybeSingle();

      if (existing) {
        console.log("Notification already exists, skipping:", data.type, data.related_booking_id);
        return false;
      }
    }

    const { error } = await supabase.from("notifications").insert(data);

    if (error) {
      console.error("Error inserting notification:", error);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error in insertNotificationOnce:", error);
    return false;
  }
}
